export default class P2pPagination {
    page;
    totalPages;
    paginationContainer;
    nextButton;
    prevButton;
    currentIndicator;

    constructor() {
        this.page = 1;
        this.paginationContainer = document.getElementById("p2p-gallery-pagination");
    }

    init() {
        if(!this.paginationContainer) return;
        this.totalPages = (this.paginationContainer ? this.paginationContainer.dataset.totalPages : 1) * 1;
        this.nextButton = this.paginationContainer.querySelector('.next');
        this.prevButton = this.paginationContainer.querySelector('.prev');
        this.currentIndicator = this.paginationContainer.querySelector('.pagination-indicator').querySelector('.current');
        this.nextPage();
        this.prevPage();
        this.disableButtons();
    }
    nextPage() {
        let that = this;

        this.nextButton.onclick = function(e) {
            console.log(that.page);
            if(that.page === that.totalPages) return;
            that.page++;
            that.paginate();
        };

    }
    prevPage() {
        let that = this;
        this.prevButton.onclick = function(e) {
            if(that.page === 1) return;
            that.page--;
            that.paginate();
        };

    }
    paginate() {
        this.disableButtons();
        let displayProperty
        document.querySelectorAll('.p2p-product-gallery--item').forEach((galleryItem) => {
            displayProperty = galleryItem.dataset.page != this.page ? "none" : 'block';
            galleryItem.style.display = displayProperty;
        });
    }
    disableButtons() {
        if(this.page === 1) {
            this.prevButton.classList.add('disabled');
        } else {
            this.prevButton.classList.remove('disabled');
        }
        if(this.page === this.totalPages) {
            this.nextButton.classList.add('disabled');
        } else {
            this.nextButton.classList.remove('disabled');
        }
        this.currentIndicator.innerHTML = this.page < 10 ? `0${this.page}` : this.page;
    }
}